import { Component } from '@angular/core';
import { Parametro } from './interfaces/parametro.interface';
import { ParametroServiceService } from './services/parametro-service.service';
import { TipoParametro } from './enum/enum';

@Component({
    selector: 'app-parametros',
    templateUrl: './parametros.component.html',
    styleUrls: ['./parametros.component.css'],
})
export class ParametrosComponent {
    listaParametros: Parametro[];
    originalParamValues: { [key: number]: any } = {}; // Para guardar valores originales al editar
    searchTerm = '';
    filteredParam: Parametro[] = [];

    // Usando el enum (Opción 1)
    tiposParametro = Object.entries(TipoParametro).map(([key, value]) => ({
        key,
        value,
    }));

    constructor(private parametroService: ParametroServiceService) {}

    async ngOnInit() {
        await this.mostrarParametros();
    }

    getTipoNombre(tipoKey: string): string {
        return TipoParametro[tipoKey as keyof typeof TipoParametro] || tipoKey;
    }

    async mostrarParametros() {
        try {
            const data = await this.parametroService.getParams('parametro');
            this.listaParametros = data;
            this.filterParams();
        } catch (error) {
            console.error('Error consultando parámetros:', error);
            throw error;
        }
    }

    filterParams() {
        const term = this.searchTerm.toLowerCase();
        this.filteredParam = this.listaParametros.filter(
            (param) =>
                param.nombre?.toLowerCase().includes(term) ||
                param.valor?.toString().includes(term)
        );
    }

    validarValor(param: any) {
        param.invalido = false;
        const tipo = param.tipo
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .toLowerCase();

        if (tipo === 'fecha') {
            const regexFecha = /^\d{2}-\d{2}-\d{4}$/;
            if (!regexFecha.test(param.valor)) {
                param.invalido = true;
            } else {
                // Validar si la fecha realmente existe
                const [day, month, year] = param.valor.split('-').map(Number);
                const date = new Date(year, month - 1, day);
                // Validar que la fecha formada coincida con el input
                param.invalido = !(
                    date.getFullYear() === year &&
                    date.getMonth() === month - 1 &&
                    date.getDate() === day
                );
            }
        } else if (tipo === 'numero') {
            const regexNumero = /^-?\d+(\.\d+)?$/;
            param.invalido = !regexNumero.test(param.valor);
        } else if (tipo === 'texto') {
            const regexTexto = /^[a-zA-Z\sáéíóúÁÉÍÓÚñÑ]+$/;
            param.invalido = !regexTexto.test(param.valor);
        }

        console.log(
            'Valor:',
            param.valor,
            'Tipo:',
            param.tipo,
            'Normalizado:',
            tipo,
            'Inválido:',
            param.invalido
        );
    }

    enableEditing(param: Parametro) {
        this.originalParamValues[param.id] = param.valor; // Guardar valor original
        param.editing = true;
    }

    cancelEditing(param: Parametro) {
        param.valor = this.originalParamValues[param.id]; // Restaurar valor original
        param.editing = false;
        delete this.originalParamValues[param.id];
    }

    async saveParam(param: Parametro) {
        try {
            await this.parametroService.updateParam('parametro', param.id, {
                valor: param.valor,
            });
            param.editing = false;
            delete this.originalParamValues[param.id];
        } catch (error) {
            console.error('Error al guardar parámetro:', error);
            // Podrías mostrar un mensaje de error al usuario aquí
        }
    }
}
